/* Kategorie PLP: quick-buy size buttons, sort select, "load more" button.
   Quick-buy uses the same add-to-cart flow as Dawn's product-form.js. */
(function () {
  if (window.plpBrutalistInit) return;
  window.plpBrutalistInit = true;

  function quickAdd(button) {
    if (button.classList.contains('is-loading')) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }
    config.body = formData;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'plp-quick-add',
              productVariantId: button.dataset.variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          button.disabled = true;
          button.title = response.description || response.message || '';
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'plp-quick-add',
            productVariantId: button.dataset.variantId,
            cartData: response,
          });
        }
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1200);
        cart.renderContents(response);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  function loadMore(link) {
    if (link.classList.contains('is-loading')) return;

    const sectionId = link.dataset.sectionId;
    const grid = document.getElementById(`PlpGrid-${sectionId}`);
    const label = link.textContent;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    link.classList.add('is-loading');
    link.textContent = link.dataset.loadingLabel;

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll(`#PlpGrid-${sectionId} > .plp__item`);
        items.forEach((item) => grid.appendChild(document.importNode(item, true)));

        const nextLink = doc.querySelector('.plp__more');
        if (nextLink) {
          link.href = nextLink.getAttribute('href');
          link.textContent = label;
          link.classList.remove('is-loading');
        } else {
          link.remove();
        }
      })
      .catch((error) => {
        console.error(error);
        window.location = link.href;
      });
  }

  document.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('.plp-card__size[data-variant-id]');
    if (sizeButton) {
      event.preventDefault();
      quickAdd(sizeButton);
      return;
    }

    const moreLink = event.target.closest('.plp__more');
    if (moreLink) {
      event.preventDefault();
      loadMore(moreLink);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.plp__sort-select')) return;
    event.target.form.submit();
  });
})();
